import _ from "lodash";

const makeQueryString = (obj: { [key: string]: string | number | boolean }) =>
  "?" + _.map(obj, (value, key) => `${key}=${value}`).join("&");

export default makeQueryString;
